function Cinema_booking_table(element) {
  this.dataTableShowIds = [];
  if (element.dataset.tableShowIds.length > 0) {
    this.dataTableShowIds = element.dataset.tableShowIds.split(',');
  }
  this.allDataTableShowIds = [];
  if (element.dataset.allTableShowIds.length > 0) {
    this.allDataTableShowIds = element.dataset.allTableShowIds.split(',');
  }
  this.element = element;
  this.show_select = document.querySelector('select#show_id');

    this.init = function() {
      var that = this;
      this.show_select.addEventListener('change', function() {
        that.update_form(that.show_select);
      });
      this.update_form(this.show_select);
    };

    this.update_form = function(element) {
      let showTableInput = this.dataTableShowIds.includes(element.value);
      const tableInputElement = document.querySelector('#choice_table_booking');
      const noticeElement = document.querySelector('#table_booking_impossible');
      if (showTableInput) {
        tableInputElement.classList.remove('hidden');
        noticeElement.classList.add('hidden');
      } else {
        tableInputElement.classList.add('hidden');
        if (this.show_select.value > 0 && !this.allDataTableShowIds.includes(this.show_select.value)) {
          noticeElement.classList.remove('hidden');
        }
      }
    };
}
